import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-black text-white p-4 flex flex-col md:flex-row justify-between items-center relative z-50">
      <div className="flex flex-col items-start md:items-start md:flex-col w-full md:w-auto">
        <div className="flex items-center justify-between w-full md:w-auto">
          <div
            className="text-3xl md:text-5xl font-bold hover:text-green-500 transition-colors duration-500 cursor-pointer"
            onClick={() => window.location.href = '/'}
          >
            Amit Kedia
          </div>
          <button className="flex md:hidden ml-2" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
          </button>
        </div>
        <div className="text-sm md:text-lg mt-1">Data and AI Learnings</div>
      </div>
      <div className="space-x-6 hidden md:flex text-lg mt-2 md:mt-0">
        <Link to="/portfolio" className="hover:text-green-500 transition-colors duration-500 hover:underline">Portfolio</Link>
        <Link to="/blog" className="hover:text-green-500 transition-colors duration-500 hover:underline">Blog</Link>
        <Link to="/services" className="hover:text-green-500 transition-colors duration-500 hover:underline">Services</Link>
        <Link to="/about" className="hover:text-green-500 transition-colors duration-500 hover:underline">About</Link>
      </div>
      <div
        className={`fixed inset-0 bg-black bg-opacity-90 flex flex-col items-center justify-center transition-transform transform ${
          isMenuOpen ? 'scale-y-100' : 'scale-y-0'
        } origin-top z-40`}
      >
        <button className="absolute top-4 right-4" onClick={() => setIsMenuOpen(false)}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
        <Link to="/portfolio" className="hover:text-green-500 transition-colors duration-500 hover:underline my-2" onClick={() => setIsMenuOpen(false)}>Portfolio</Link>
        <Link to="/blog" className="hover:text-green-500 transition-colors duration-500 hover:underline my-2" onClick={() => setIsMenuOpen(false)}>Blog</Link>
        <Link to="/services" className="hover:text-green-500 transition-colors duration-500 hover:underline my-2" onClick={() => setIsMenuOpen(false)}>Services</Link>
        <Link to="/about" className="hover:text-green-500 transition-colors duration-500 hover:underline my-2" onClick={() => setIsMenuOpen(false)}>About</Link>
      </div>
    </header>
  );
};

export default Header;
